'use strict';

var spacer = require('../../../../../../../../../../_virtual/spacer.cjs');

(function (exports) {

	exports.SpacerSizes = void 0;
	(function(SpacerSizes) {
	    SpacerSizes[SpacerSizes["quarter"] = 4] = "quarter";
	    SpacerSizes[SpacerSizes["half"] = 8] = "half";
	    SpacerSizes[SpacerSizes["one"] = 16] = "one";
	    SpacerSizes[SpacerSizes["oneQuarter"] = 20] = "oneQuarter";
	    SpacerSizes[SpacerSizes["oneHalf"] = 24] = "oneHalf";
	    SpacerSizes[SpacerSizes["double"] = 32] = "double";
	    SpacerSizes[SpacerSizes["doubleHalf"] = 40] = "doubleHalf";
	    SpacerSizes[SpacerSizes["triple"] = 48] = "triple";
	    SpacerSizes[SpacerSizes["tripleHalf"] = 56] = "tripleHalf";
	    SpacerSizes[SpacerSizes["quad"] = 64] = "quad";
	})(exports.SpacerSizes || (exports.SpacerSizes = {}));
	
} (spacer.__exports));
//# sourceMappingURL=spacer.cjs.map
